import { Fragment, useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Modal, TreeSelect, message, Row, Col, Statistic, Space, ConfigProvider } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { CheckImgs } from "../../component/common/Imgs"
import { SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'
import { Link } from "react-router-dom"
import moment from "moment"

import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker


type fetchParams = {
    store_id: string | undefined,
    meal_times: number | undefined,
    menu_date: any,
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

interface ep {
    "employee_id": string,
    "user_name": string
}


export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        menu_date: null,
        store_id: undefined,
        meal_times: undefined,
    }

    const [currentType, setCurrentType] = useState<number>(0)

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [gjData, setGjData] = useState<ep[]>([])
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [pagination2, setPagination2] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [pagination3, setPagination3] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [data, setData] = useState<any>([])
    const [data2, setData2] = useState<any>([])
    const [data3, setData3] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [inStoreRecordVisible, setInStoreRecordVisible] = useState<boolean>(false)
    const [inStoreRecordData, setInStoreRecordData] = useState<any[]>([])

    const [followRecordVisible, setFollowRecordVisible] = useState<boolean>(false)
    const [followRecordData, setFollowRecordData] = useState<any[]>([])

    const [inMoneyRecordVisible, setInMoneyRecordVisible] = useState<boolean>(false)
    const [inMoneyRecordData, setInMoneyRecordData] = useState<any>({ "total_agreement_amount": 0, "total_review_amount": 0, "total_pay_amount": 0, pay_records_list: [] })

    const [lossVisible, setLossVisible] = useState<boolean>(false)
    const [lossData, setLossData] = useState<any[]>([])
    const [yys, setYys] = useState<any[]>([])
    const [current, setCurrent] = useState<number>(0)

    const permission: string[] = useMemo(() => {
        console.log(getPermission()) // ['查询', '导出']
        return getPermission()
    }, [window.location.pathname])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value
        setFetchOtherParams(params)
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }
    const handleTableChange2 = (antPagination: any) => {
        const p = { ...pagination2 }
        p.current = antPagination.current
        setPagination2(p)
    }
    const handleTableChange3 = (antPagination: any) => {
        const p = { ...pagination3 }
        p.current = antPagination.current
        setPagination3(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        if(params.menu_date){
            params.menu_date = moment(params.menu_date).format('YYYY-MM-DD')
        }


        // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/cooking/order_list/by_room_number/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total
                setPagination(p)
                setData(response.records)
            }
            setLoading(false)
        })
    }

    const fetch2 = ({ pagination2, fetchOtherParams }: { pagination2: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination2 }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }

        if(params.menu_date){
            params.menu_date = moment(params.menu_date).format('YYYY-MM-DD')
        }
        // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/cooking/order_list/by_menu_item/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination2 }
                p.total = response.total
                setPagination2(p)
                setData2(response.records)
            }
            setLoading(false)
        })
    }

    const fetch3 = ({ pagination3, fetchOtherParams }: { pagination3: Object, fetchOtherParams: Object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination2 }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current


        let params: any = { ...fetchOtherParams }

        if(params.menu_date){
            params.menu_date = moment(params.menu_date).format('YYYY-MM-DD')
        }

        // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
        // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

        axiosTable.get('/cooking/order_list/by_position/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination3 }
                p.total = response.total
                setPagination3(p)
                setData3(response.records)
            }
            setLoading(false)
        })
    }

    const handleSearch = () => {
        if (fetchOtherParams.menu_date) {
            if(current===0){
                const p = { ...pagination }
                p.current = 1
                fetch({ pagination: p, fetchOtherParams })
            }else if(current==1){
                const p = { ...pagination2 }
                p.current = 1
                fetch2({ pagination2: p, fetchOtherParams })
            }else{
                const p = { ...pagination3 }
                p.current = 1
                fetch3({ pagination3: p, fetchOtherParams })
            }
        }else{
            message.error('必须选择日期')
        }
    }


    useEffect(() => {
        if (fetchOtherParams.menu_date) {
            fetch({ pagination, fetchOtherParams })
        }else{
            message.error('必须选择日期')
        }
    }, [pagination.current])

    useEffect(() => {
        if (fetchOtherParams.menu_date) {
            fetch2({ pagination2, fetchOtherParams })
        }
    }, [pagination2.current])

    useEffect(() => {
        if (fetchOtherParams.menu_date) {
            fetch3({ pagination3, fetchOtherParams })
        }
    }, [pagination3.current])

    // useEffect(()=>{
    //     baseAxiosNoInfo('/keeper/check_in/wait_distribute_page_list',{params:{
    //         page:1,
    //         size:8
    //     }}).then((res:any)=>{
    //         let num = res.total || 0
    //         let totalData = {...dataTotals}
    //         totalData[1].total = num
    //         setDataTotals(totalData)
    //     })
    // },[])


    const exportExcel = () => {
        message.success('此次导出需要较长时间，请稍等..')
        if (current === 0) {
            const iPagination: any = { ...pagination }
            iPagination.size = iPagination.pageSize
            iPagination.page = iPagination.current
            delete iPagination.pageSize
            delete iPagination.total
            delete iPagination.current
            delete iPagination.showSizeChanger

            let params: any = { ...fetchOtherParams }

            if(params.menu_date){
                params.menu_date = moment(params.menu_date).format('YYYY-MM-DD')
            }
            // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

            baseAxiosComplete('/cooking/order_list/by_room_number/export', {
                params: {
                    ...iPagination,
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }

        if (current === 1) {
            const iPagination: any = { ...pagination2 }
            iPagination.size = iPagination.pageSize
            iPagination.page = iPagination.current
            delete iPagination.pageSize
            delete iPagination.total
            delete iPagination.current
            delete iPagination.showSizeChanger

            let params: any = { ...fetchOtherParams }

            if(params.menu_date){
                params.menu_date = moment(params.menu_date).format('YYYY-MM-DD')
            }
            // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

            baseAxiosComplete('/cooking/order_list/by_menu_item/export', {
                params: {
                    ...iPagination,
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }

        if (current === 2) {
            const iPagination: any = { ...pagination3 }
            iPagination.size = iPagination.pageSize
            iPagination.page = iPagination.current
            delete iPagination.pageSize
            delete iPagination.total
            delete iPagination.current
            delete iPagination.showSizeChanger

            let params: any = { ...fetchOtherParams }

            if(params.menu_date){
                params.menu_date = moment(params.menu_date).format('YYYY-MM-DD')
            }
            // handleDate(params, 'checkInDay', ['check_in_start_day', 'check_in_end_day'])
            // handleDate(params, 'checkOutDay', ['check_out_start_day', 'check_out_end_day'])

            baseAxiosComplete('/cooking/order_list/by_position/export', {
                params: {
                    ...iPagination,
                    ...params
                }
            }).then(res => {
                if (res.status === 0) {
                    window.open(res.data)
                }
            })
        }
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    return (<div className="common-page">
        <BreadCrumb position={['膳食中心', '历史客餐订单']} />
        <div className="common-top-form">
            {<div className="clear">

                <DatePicker className="fl" style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="选择日期" value={fetchOtherParams.menu_date} onChange={(v: any) => {
                    let s = _.cloneDeep(fetchOtherParams)
                    s.menu_date = v
                    setFetchOtherParams(s)
                }} />
                


                <div className="fl" style={{ marginRight: 12 }}>
                    <Select placeholder="按房号、菜品、岗位分类" style={{ width: 200 }} value={current} onChange={(v: number) => {
                        setCurrent(v)
                    }}>
                        <Option key={0} value={0}>房号</Option>
                        <Option key={1} value={1}>菜品</Option>
                        <Option key={2} value={2}>岗位分类</Option>
                    </Select>
                </div>
                <div className="fl" style={{ marginRight: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        // baseAxiosNoInfo('/global/employee_list_by_position', {
                        //     params: {
                        //         department_id: v
                        //     }
                        // }).then((res: any) => {
                        //     res && setYys(res)
                        // })
                        let s = _.cloneDeep(fetchOtherParams)
                        s.store_id = v
                        setFetchOtherParams(s)
                    }} />
                </div>
                <Select allowClear className="fl" virtual={false} style={{ width: 150, marginRight: 12, marginBottom: 12 }} placeholder="餐次" value={fetchOtherParams.meal_times} onChange={(v: number) => { handleChange(v, 'meal_times') }}>
                    <Option value={1} key={1}>早餐</Option>
                    <Option value={2} key={2}>加餐</Option>
                    <Option value={3} key={3}>午餐</Option>
                    <Option value={4} key={4}>间餐</Option>
                    <Option value={5} key={5}>晚餐</Option>
                    <Option value={6} key={6}>宵夜</Option>
                </Select>

                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button> }
                <Button className="fl" style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button className="fl" onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>}
        </div>
        <div className="common-main">
        {current === 0 && <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true}  pagination={pagination} onChange={handleTableChange}>
                <Column  title="用餐日期" dataIndex="menu_date" key="menu_date" />
                <Column  title="房号" dataIndex="room_number" key="room_number" />
                <Column title="阶段" dataIndex="stage_number_desc" key="stage_number_desc" />
                <Column title="餐次" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="服务对象" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="营养师" dataIndex="belong_dietician_name" key="belong_dietician_name" />
                <Column title="菜品" dataIndex="menu_item_list" key="menu_item_list" render={(v: any[]) => {
                    return <Space>
                        {/* {v.map((el:any)=><span>{el.menu_item_list}</span>)} */}
                        {v.map((el=>{
                            let s = ''
                            switch(el.sugar_status){
                                case 0:
                                    s = '默认'
                                    break;
                                case 1:
                                    s = '去糖'
                                break;
                                case 2:
                                    s = '少糖'
                                break;
                                case 3:
                                    s = '多糖'
                                break;
                            }
                            let s2 = ''
                            switch(el.salt_status){
                                case 0:
                                    s2 = '默认'
                                break;
                                case 1:
                                    s2 = '去盐'
                                break;
                                case 2:
                                    s2 = '少盐'
                                break;
                                case 3:
                                    s2 = '多盐'
                                break;
                            }
                            
                            return <span>
                                {el.menu_item_name}  
                                {s !== '默认' &&  <i style={{color:'orange',fontStyle:'normal'}}>({s}) </i>} 
                                {s2 !== '默认' && <i style={{color:'orange',fontStyle:'normal'}}>({s2}) </i>}
                                <i style={{color:'red',fontStyle:'normal'}}>【{el.menu_item_count}】</i>
                            </span>
                        }))}
                    </Space>
                }} />
                <Column title="下单时间" dataIndex="order_time" key="order_time" />
                <Column title="下单人" dataIndex="order_operator_name" key="order_operator_name" />
            </Table>}

            {current === 1 && <Table loading={loading} dataSource={data2} scroll={{ x: 'max-content' }} bordered={true}  pagination={pagination2} onChange={handleTableChange2}>
                <Column  title="用餐日期" dataIndex="menu_date" key="menu_date" />
                <Column title="餐次" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="菜品" render={(v: any) => {
                    let s = ''
                    switch(v.sugar_status){
                        case 0:
                            s = '默认'
                        break;
                        case 1:
                            s = '去糖'
                        break;
                        case 2:
                            s = '少糖'
                        break;
                        case 3:
                            s = '多糖'
                        break;
                    }
                    let s2 = ''
                    switch(v.salt_status){
                        case 0:
                            s2 = '默认'
                        break;
                        case 1:
                            s2 = '去盐'
                        break;
                        case 2:
                            s2 = '少盐'
                        break;
                        case 3:
                            s2 = '多盐'
                        break;
                    }
                    
                    return <span>
                        {v.menu_item_name}
                        {/* {s !== '默认' &&  <i style={{color:'orange',fontStyle:'normal'}}>,({s})</i>}
                        {s2 !== '默认' && <i style={{color:'orange',fontStyle:'normal'}}>,({s2})</i>} */}
                        {/* <i style={{color:'red',fontStyle:'normal'}}>,总数【{v.total_menu_item_count}】</i> */}
                    </span>
                }} />
                <Column title="房号" dataIndex="room_number_list" key="room_number_list" render={(v:[])=>{
                    return <Space>
                        {v.map((el:any)=><Space>
                            <span>{el.room_number}</span><span style={{color:'red'}}>【{el.menu_item_count}】</span>、
                        </Space>)}
                    </Space>
                }}/>
                <Column title="口味偏好" dataIndex="taste_favors" key="taste_favors"/>
                <Column title="总数量" dataIndex="total_menu_item_count" key="total_menu_item_count"/>
            </Table>}

            
            {current === 2 && <Table loading={loading} dataSource={data3} scroll={{ x: 'max-content' }} bordered={true}  pagination={pagination3} onChange={handleTableChange3}>
                <Column  title="用餐日期" dataIndex="menu_date" key="menu_date" />
                <Column title="餐次" dataIndex="meal_times_desc" key="meal_times_desc" />
                <Column title="岗位" dataIndex="position_name" key="position_name" />
                <Column title="菜品" dataIndex="menu_item_list" key="menu_item_list" render={(v: any[]) => {
                    return <Space>
                        {/* {v.map((el:any)=><span>{el.menu_item_list}</span>)} */}
                        {v && v.map((el=>{
                            let s = ''
                            switch(el.sugar_status){
                                case 0:
                                    s = '默认'
                                break;
                                case 1:
                                    s = '去糖'
                                break;
                                case 2:
                                    s = '少糖'
                                break;
                                case 3:
                                    s = '多糖'
                                break;
                            }
                            let s2 = ''
                            switch(el.salt_status){
                                case 0:
                                    s2 = '默认'
                                break;
                                case 1:
                                    s2 = '去盐'
                                break;
                                case 2:
                                    s2 = '少盐'
                                break;
                                case 3:
                                    s2 = '多盐'
                                break;
                            }
                            
                            return <span>
                                {el.menu_item_name}{s !== '默认' &&  <i style={{color:'orange',fontStyle:'normal'}}>,({s})</i>}
                                {s2 !== '默认' && <i style={{color:'orange',fontStyle:'normal'}}>,({s2})</i>}
                                <i style={{color:'red',fontStyle:'normal'}}>【{el.menu_item_count}】</i>
                            </span>
                        }))}
                    </Space>
                }} />
            </Table>}
        </div>

    </div>)
}